import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import cookie from "js-cookie";
import NavBar from "./NavBar";
import { notify_error, notify_success } from "./Notify";
import StudentProfile from "./Studentprofile";
import ProgressBar from "./ProgressBar";
import LeadRemarks from "./LeadRemarks";
import EnquiryAPI from "../utils/api/EnquiryAPI";
import OnlineEnquiryAPI from "../utils/api/OnlineEnquiryAPI";
import Duplicates from "./Duplicates";
import LeadViewLogs from "./LeadViewLogs";
import { LeadProfileShell, LeadProfileCard } from "./LeadProfileShell";

const LeadProfile = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [data, setDate] = useState({});

  const handleRefresh = () => {
    EnquiryAPI.getOneEnquiry(id)
      .then((res) => setDate(res.data.data[0] || {}))
      .catch((err) => notify_error(err.message || "Something Went Wrong"));
  };

  useEffect(() => {
    if (!id) return;
    EnquiryAPI.getOneEnquiry(id)
      .then((res) => {
        const lead = res.data.data[0];
        if (!lead) return;
        setDate(lead);
        if (lead.isReassigned && !lead.hasNewAssigneeResponded) {
          if (
            cookie.get("name") === lead.assignedTo ||
            cookie.get("name") === lead.handled_by
          ) {
            OnlineEnquiryAPI.updateReassignResponse(id)
              .then(() => notify_success("Reassigned Enquiry Handled"))
              .catch(() =>
                notify_error("Reassigned Enquiry Handle Status Couldn't be updated")
              );
          }
        }
      })
      .catch((err) => notify_error(err.message || "Something Went Wrong"));
  }, [id]);

  return (
    <>
      <NavBar />
      <LeadProfileShell
        crumb="Lead Profile"
        name={data?.name}
        status={data?.admissionStatus}
        onBack={() => navigate("/dashboard/enquiry-table")}
      >
        <div className="lp-grid">
          <div>
            <LeadProfileCard title="Lead Details">
              <StudentProfile data={data} handleRefresh={handleRefresh} />
            </LeadProfileCard>
            <LeadProfileCard title="Duplicates">
              <Duplicates data={data} />
            </LeadProfileCard>
          </div>

          <div>
            <LeadProfileCard title="Admission Progress">
              <ProgressBar id={id} />
            </LeadProfileCard>
            <LeadProfileCard title="Remarks & Activity" style={{ padding: "18px 8px" }}>
              <LeadRemarks data={data} />
            </LeadProfileCard>
            <LeadViewLogs leadId={id} />
          </div>
        </div>
      </LeadProfileShell>
    </>
  );
};

export default LeadProfile;
